// Hong Kong Public Holidays (General Holidays Ordinance, Cap. 149)
// Verify latest dates at: https://www.gov.hk/en/about/abouthk/holiday/

export interface HKHoliday {
  date: string; // YYYY-MM-DD
  name: string;
}

const HOLIDAYS: HKHoliday[] = [
  // ── 2025 ──────────────────────────────────────────────────────────
  { date: '2025-01-01', name: "New Year's Day" },
  { date: '2025-01-29', name: "Lunar New Year's Day" },
  { date: '2025-01-30', name: '2nd Day of Lunar New Year' },
  { date: '2025-01-31', name: '3rd Day of Lunar New Year' },
  { date: '2025-04-04', name: 'Ching Ming Festival' },
  { date: '2025-04-18', name: 'Good Friday' },
  { date: '2025-04-19', name: 'Day After Good Friday' },
  { date: '2025-04-21', name: 'Easter Monday' },
  { date: '2025-05-01', name: 'Labour Day' },
  { date: '2025-05-05', name: "Buddha's Birthday" },
  { date: '2025-06-02', name: 'Tuen Ng Festival' },
  { date: '2025-07-01', name: 'HKSAR Establishment Day' },
  { date: '2025-09-08', name: 'Day After Mid-Autumn Festival' },
  { date: '2025-10-01', name: 'National Day' },
  { date: '2025-10-07', name: 'Chung Yeung Festival' },
  { date: '2025-12-25', name: 'Christmas Day' },
  { date: '2025-12-26', name: 'First Weekday After Christmas' },

  // ── 2026 ──────────────────────────────────────────────────────────
  { date: '2026-01-01', name: "New Year's Day" },
  { date: '2026-02-17', name: "Lunar New Year's Day" },
  { date: '2026-02-18', name: '2nd Day of Lunar New Year' },
  { date: '2026-02-19', name: '3rd Day of Lunar New Year' },
  { date: '2026-04-03', name: 'Good Friday' },
  { date: '2026-04-04', name: 'Day After Good Friday' },
  { date: '2026-04-05', name: 'Ching Ming Festival' },
  { date: '2026-04-06', name: 'Easter Monday' },
  { date: '2026-05-01', name: 'Labour Day' },
  { date: '2026-05-25', name: "Buddha's Birthday" },
  { date: '2026-06-19', name: 'Tuen Ng Festival' },
  { date: '2026-07-01', name: 'HKSAR Establishment Day' },
  { date: '2026-09-25', name: 'Day After Mid-Autumn Festival' },
  { date: '2026-10-01', name: 'National Day' },
  { date: '2026-10-26', name: 'Chung Yeung Festival' },
  { date: '2026-12-25', name: 'Christmas Day' },
  { date: '2026-12-28', name: 'First Weekday After Christmas' },
];

const HOLIDAY_MAP = new Map<string, string>(HOLIDAYS.map(h => [h.date, h.name]));

/** Format a local Date as YYYY-MM-DD (avoids UTC shift from toISOString) */
export function toLocalDateStr(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function getHKHolidayName(dateStr: string): string | undefined {
  return HOLIDAY_MAP.get(dateStr);
}

export function isHKHoliday(dateStr: string): boolean {
  return HOLIDAY_MAP.has(dateStr);
}

export function isWeekend(date: Date): boolean {
  const day = date.getDay();
  return day === 0 || day === 6;
}

export function isWorkingDay(date: Date): boolean {
  return !isWeekend(date) && !isHKHoliday(toLocalDateStr(date));
}

/** Count Mon–Fri working days between two YYYY-MM-DD strings (inclusive), excluding HK public holidays */
export function countWorkingDays(startDateStr: string, endDateStr: string): number {
  const cur = new Date(startDateStr + 'T00:00:00');
  const end = new Date(endDateStr + 'T00:00:00');
  let count = 0;
  while (cur <= end) {
    if (isWorkingDay(cur)) count++;
    cur.setDate(cur.getDate() + 1);
  }
  return count;
}
